import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ion-text-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  class: "ion-text-center",
  style: {"margin-bottom":"100px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_radio = _resolveComponent("ion-radio")!
  const _component_ion_radio_group = _resolveComponent("ion-radio-group")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, { fixed: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.t('checkout')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_back_button, { "default-href": "/cart" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, { fixed: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_list_header, { color: "primary" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.t('CheckoutPage.yourOrder')), 1)
                    ]),
                    _: 1
                  }),
                  ($setup.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_ion_spinner)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.groupedCartItems, (obj, merchantId) => {
                          return (_openBlock(), _createBlock(_component_ion_card, { key: merchantId }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_content, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, { lines: "none" }, {
                                    default: _withCtx(() => [
                                      (obj.merchant.logo)
                                        ? (_openBlock(), _createBlock(_component_ion_avatar, {
                                            key: 0,
                                            slot: "start"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("img", {
                                                src: obj.merchant.logoLink
                                              }, null, 8, _hoisted_3)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_ion_label, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_text, { color: "primary" }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("h2", null, [
                                                _createElementVNode("b", null, _toDisplayString(obj.merchant.name), 1)
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _withDirectives(_createElementVNode("h3", null, _toDisplayString($setup.t('CheckoutPage.shippingTotal')) + "HK$" + _toDisplayString(obj.merchant.shippingTotal), 513), [
                                            [_vShow, obj.merchant.shippingTotal]
                                          ]),
                                          _createElementVNode("h3", null, [
                                            _createElementVNode("b", null, _toDisplayString($setup.t('CartPage.lineTotal')) + "HK$" + _toDisplayString(obj.totalPrice + Number(obj.merchant.shippingTotal || 0)), 1)
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_item, { lines: "full" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(obj.cartItems, (item, index) => {
                                            return (_openBlock(), _createElementBlock("p", {
                                              key: item.productId
                                            }, [
                                              _createTextVNode(_toDisplayString(index+1) + ". ", 1),
                                              _withDirectives(_createElementVNode("span", null, "[" + _toDisplayString($setup.t('customizedProduct')) + "] ", 513), [
                                                [_vShow, item.isCustomized]
                                              ]),
                                              _createElementVNode("b", null, _toDisplayString(item.productName) + " x " + _toDisplayString(item.quantity) + " (HK$" + _toDisplayString(Number(item.unitPrice * item.quantity).toLocaleString()) + ")", 1),
                                              _hoisted_4
                                            ]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_segment, {
                                    modelValue: obj.merchant.deliveryMethod,
                                    "onUpdate:modelValue": ($event: any) => ((obj.merchant.deliveryMethod) = $event),
                                    onIonChange: ($event: any) => ($setup.syncMerchantShippingTotal(obj))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_segment_button, { value: "送貨上門" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, { icon: $setup.homeOutline }, null, 8, ["icon"]),
                                          _createVNode(_component_ion_label, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString($setup.t('CartItemModal.delivery')), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _withDirectives(_createVNode(_component_ion_segment_button, { value: "自取" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, { icon: $setup.storefrontOutline }, null, 8, ["icon"]),
                                          _createVNode(_component_ion_label, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString($setup.t('CartItemModal.pickup')), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1536), [
                                        [_vShow, obj.pickupPoints.length > 0]
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "onIonChange"]),
                                  _withDirectives(_createElementVNode("div", null, [
                                    _createVNode(_component_ion_segment, {
                                      modelValue: obj.merchant.deliveryRegionFilter,
                                      "onUpdate:modelValue": ($event: any) => ((obj.merchant.deliveryRegionFilter) = $event),
                                      scrollable: "",
                                      onIonChange: ($event: any) => (obj.merchant.deliveryDistrict = '')
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(obj.groupedDeliveryOptions), (region) => {
                                          return (_openBlock(), _createBlock(_component_ion_segment_button, {
                                            key: region,
                                            value: region
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString($setup.t(region)), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1032, ["value"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue", "onIonChange"]),
                                    _withDirectives(_createVNode(_component_ion_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_select, {
                                          label: $setup.t('deliveryDistrict'),
                                          "label-placement": "stacked",
                                          placeholder: $setup.t('CartItemModal.selectDistrict'),
                                          interface: "popover",
                                          modelValue: obj.merchant.deliveryDistrict,
                                          "onUpdate:modelValue": ($event: any) => ((obj.merchant.deliveryDistrict) = $event),
                                          onIonChange: ($event: any) => ($setup.syncMerchantShippingTotal(obj))
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getDeliveryOptions(obj.groupedDeliveryOptions, obj.merchant.deliveryRegionFilter), (option) => {
                                              return (_openBlock(), _createBlock(_component_ion_select_option, {
                                                key: option.label,
                                                value: option.label
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(option.label), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["value"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["label", "placeholder", "modelValue", "onUpdate:modelValue", "onIonChange"])
                                      ]),
                                      _: 2
                                    }, 1536), [
                                      [_vShow, obj.merchant.deliveryRegionFilter]
                                    ]),
                                    _createVNode(_component_ion_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, { position: "stacked" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.t('deliveryAddress')), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ion_textarea, {
                                          placeholder: $setup.t('CartItemModal.enterDeliveryAddress'),
                                          modelValue: obj.merchant.deliveryAddress,
                                          "onUpdate:modelValue": ($event: any) => ((obj.merchant.deliveryAddress) = $event)
                                        }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ], 512), [
                                    [_vShow, obj.merchant.deliveryMethod == '送貨上門']
                                  ]),
                                  _withDirectives(_createElementVNode("div", null, [
                                    _createVNode(_component_ion_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, { position: "stacked" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.t('CartItemModal.pickupPoint')), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ion_select, {
                                          placeholder: $setup.t('CartItemModal.selectPickupPoint'),
                                          interface: "popover",
                                          modelValue: obj.merchant.pickupPoint,
                                          "onUpdate:modelValue": ($event: any) => ((obj.merchant.pickupPoint) = $event),
                                          onIonChange: ($event: any) => ($setup.onPickupPointChanged(obj))
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(obj.pickupPoints, (point) => {
                                              return (_openBlock(), _createBlock(_component_ion_select_option, {
                                                key: point.id,
                                                value: point.id
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(point.name ? `[${point.name}] ` : "") + _toDisplayString(point.address), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["value"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["placeholder", "modelValue", "onUpdate:modelValue", "onIonChange"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ], 512), [
                                    [_vShow, obj.merchant.deliveryMethod == '自取']
                                  ]),
                                  _createVNode(_component_ion_item, { lines: "none" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, {
                                        position: "stacked",
                                        style: {"margin-bottom":"10px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(obj.merchant.deliveryMethod == '自取' ? $setup.t('CartItemModal.pickupDate') : $setup.t('CartItemModal.deliveryDate')), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_VueDatePicker, {
                                        modelValue: obj.merchant.deliveryDate,
                                        "onUpdate:modelValue": ($event: any) => ((obj.merchant.deliveryDate) = $event),
                                        enableTimePicker: false,
                                        autoApply: true,
                                        locale: "en-HK",
                                        format: "yyyy-MM-dd",
                                        minDate: obj.minDeliveryDate,
                                        disabledWeekDays: $setup.getDisabledDaysOfWeek(obj),
                                        teleport: true,
                                        clearable: false
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "minDate", "disabledWeekDays"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (obj.merchant.deliveryDate && $setup.getDeliveryTimeSlots(obj).length > 0)
                                    ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_label, { position: "stacked" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(obj.merchant.deliveryMethod == '自取' ? $setup.t('CartItemModal.pickupTime') : $setup.t('CartItemModal.deliveryTime')), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_ion_select, {
                                            placeholder: $setup.t('selectOption'),
                                            modelValue: obj.merchant.deliveryTime,
                                            "onUpdate:modelValue": ($event: any) => ((obj.merchant.deliveryTime) = $event)
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getDeliveryTimeSlots(obj), (timeSlot) => {
                                                return (_openBlock(), _createBlock(_component_ion_select_option, {
                                                  key: timeSlot.value,
                                                  value: timeSlot.value
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(timeSlot.text), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["placeholder", "modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128)),
                        _createVNode(_component_ion_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_col, {
                              "size-xs": "12",
                              "size-md": "6",
                              "size-lg": "4"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, {
                                      class: "ion-text-wrap",
                                      position: "fixed",
                                      style: {"flex":"0 0 50px","min-width":"50px"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString($setup.t('CheckoutPage.discountCode')), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_input, {
                                      modelValue: $setup.order.discountCode,
                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.order.discountCode) = $event)),
                                      disabled: $setup.order.appliedDiscountCode != ''
                                    }, null, 8, ["modelValue", "disabled"]),
                                    _withDirectives(_createVNode(_component_ion_spinner, { name: "crescent" }, null, 512), [
                                      [_vShow, $setup.order.checkingDiscountCode]
                                    ]),
                                    _withDirectives(_createVNode(_component_ion_button, {
                                      size: "default",
                                      slot: "end",
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.applyDiscountCode())),
                                      disabled: $setup.order.discountCode == ''
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, {
                                          slot: "icon-only",
                                          icon: $setup.arrowForward
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"]), [
                                      [_vShow, !$setup.order.checkingDiscountCode && $setup.order.appliedDiscountCode == '']
                                    ]),
                                    _withDirectives(_createVNode(_component_ion_button, {
                                      size: "default",
                                      fill: "clear",
                                      slot: "end",
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.resetDiscountCode()))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, {
                                          slot: "icon-only",
                                          icon: $setup.closeOutline
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    }, 512), [
                                      [_vShow, $setup.order.appliedDiscountCode]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createElementVNode("p", null, _toDisplayString($setup.t('CheckoutPage.subTotal')) + "HK$" + _toDisplayString($setup.cartTotal ? $setup.cartTotal.toLocaleString() : ""), 1),
                                _withDirectives(_createElementVNode("p", null, _toDisplayString($setup.t('CheckoutPage.discountTotal')) + "- HK$" + _toDisplayString($setup.getDiscountTotal().toFixed(1).toLocaleString()), 513), [
                                  [_vShow, $setup.getDiscountTotal() > 0]
                                ]),
                                _createElementVNode("p", null, _toDisplayString($setup.t('CheckoutPage.shippingTotal')) + "HK$" + _toDisplayString($setup.getShippingTotal().toLocaleString()), 1),
                                _createElementVNode("h3", null, [
                                  _createElementVNode("b", null, _toDisplayString($setup.t('CheckoutPage.orderTotal')) + "HK$" + _toDisplayString($setup.getOrderTotal().toFixed(1).toLocaleString()), 1)
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                ]),
                _: 1
              }),
              _createVNode(_component_ion_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_list_header, { color: "primary" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.t('CheckoutPage.contactInfo')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('customerName')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        placeholder: $setup.t('CheckoutPage.enterCustomerName'),
                        modelValue: $setup.order.customerName,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.order.customerName) = $event))
                      }, null, 8, ["placeholder", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('contactPhone')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        placeholder: $setup.t('CheckoutPage.enterContactPhone'),
                        inputmode: "numeric",
                        modelValue: $setup.order.contactPhone,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.order.contactPhone) = $event))
                      }, null, 8, ["placeholder", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('customerEmail')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        placeholder: $setup.t('CheckoutPage.enterCustomerEmail'),
                        type: "email",
                        modelValue: $setup.order.customerEmail,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.order.customerEmail) = $event))
                      }, null, 8, ["placeholder", "modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_list_header, { color: "primary" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.t('CheckoutPage.paymentInfo')) + "  ", 1),
                      _createVNode(_component_ion_icon, { icon: $setup.walletOutline }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_radio_group, {
                    modelValue: $setup.order.paymentMethod,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.order.paymentMethod) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stripePaymentMethods, (m) => {
                        return (_openBlock(), _createBlock(_component_ion_item, {
                          lines: "full",
                          key: m.id
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              icon: $setup.cardOutline,
                              slot: "start"
                            }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createElementVNode("h2", null, [
                                  (m.card.brand == 'visa')
                                    ? (_openBlock(), _createElementBlock("b", _hoisted_5, "Visa"))
                                    : (m.card.brand == 'mastercard')
                                      ? (_openBlock(), _createElementBlock("b", _hoisted_6, "MasterCard"))
                                      : (_openBlock(), _createElementBlock("b", _hoisted_7, _toDisplayString(m.card.brand), 1))
                                ]),
                                _createElementVNode("p", null, "**** " + _toDisplayString(m.card.last4), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_ion_radio, {
                              slot: "end",
                              value: m.id,
                              required: ""
                            }, null, 8, ["value"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_ion_item, {
                    lines: "full",
                    detail: "",
                    button: "",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.openNewCreditCardModal()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.cardOutline,
                        slot: "start"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('creditCard')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_radio_group, {
                    modelValue: $setup.order.paymentMethod,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.order.paymentMethod) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredPaymentMethods(), (method) => {
                        return (_openBlock(), _createBlock(_component_ion_item, {
                          key: method.value
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_radio, {
                              slot: "start",
                              value: method.value
                            }, null, 8, ["value"]),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(method.key), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_ion_icon, {
                              icon: method.icon,
                              slot: "end"
                            }, null, 8, ["icon"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _withDirectives(_createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, {
                        position: "stacked",
                        color: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('CheckoutPage.paymentProof')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        type: "file",
                        accept: "image/*",
                        onChange: _cache[9] || (_cache[9] = ($event: any) => ($setup.onPaymentProofChange($event)))
                      }),
                      ($setup.paymentProofDataURL)
                        ? (_openBlock(), _createBlock(_component_ion_buttons, {
                            key: 0,
                            slot: "end"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                slot: "icon-only",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.clearUploadedPaymentProof()))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: $setup.close }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  ($setup.paymentProofDataURL)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $setup.paymentProofDataURL,
                        style: {"display":"block","margin":"auto","max-height":"100px"}
                      }, null, 8, _hoisted_8))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 512), [
                [_vShow, $setup.order.paymentMethod == 'bank']
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_ion_button, {
                  class: "submit-btn",
                  expand: "block",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.submitOrder($setup.order))),
                  disabled: $setup.order.submittingOrder
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.t('CheckoutPage.confirmPayment')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_ion_note, null, {
                  default: _withCtx(() => [
                    _createElementVNode("small", null, [
                      _createTextVNode(_toDisplayString($setup.t('CheckoutPage.agreeTC')) + " ", 1),
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => ($setup.openTCModal()), ["prevent"]))
                      }, _toDisplayString($setup.t('CheckoutPage.orderTC')), 1)
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}